(() => {
  const initializeCueticaBuyBar = () => {
    const bar = document.querySelector('[data-cuetica-buy-bar]');
    const productInfo = document.querySelector('product-info.cuetica-main-product');
    if (!bar || !productInfo || bar.dataset.initialized === 'true') return;

    const sourceForm = productInfo.querySelector('[data-type="add-to-cart-form"]');
    const sourceSubmit = sourceForm?.querySelector('button[type="submit"]');
    const sourceVariant = sourceForm?.querySelector('input[name="id"]');
    const targetVariant = bar.querySelector('[data-cuetica-buy-variant]');
    const targetSubmit = bar.querySelector('[data-cuetica-buy-submit]');
    const targetPrice = bar.querySelector('[data-cuetica-buy-price]');
    if (!sourceForm || !sourceVariant || !targetVariant) return;

    bar.dataset.initialized = 'true';

    const sync = () => {
      targetVariant.value = sourceVariant.value;
      if (targetSubmit) targetSubmit.disabled = Boolean(sourceSubmit?.disabled);
      const sourcePrice = productInfo.querySelector('[id^="price-"] .price-item--last, [id^="price-"] .price-item--regular');
      if (targetPrice && sourcePrice) targetPrice.textContent = sourcePrice.textContent.trim();
    };

    let hasSeenSourceSubmit = false;
    const hideBar = () => {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    };
    const showBar = () => {
      bar.hidden = false;
      bar.classList.add('is-visible');
    };

    // Start hidden; the observer must not reveal the bar during the initial layout pass.
    hideBar();
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // Ignore a false intersection before the user has begun scrolling.
        if (window.scrollY > 24) hasSeenSourceSubmit = true;
        hideBar();
      } else if (hasSeenSourceSubmit) {
        showBar();
      } else {
        // Do not cover the product title/price while the real CTA is still below the fold.
        hideBar();
      }
    }, { threshold: 0.15 });

    observer.observe(sourceSubmit || sourceForm);
    sourceForm.addEventListener('change', () => window.requestAnimationFrame(sync));
    document.addEventListener('variant:change', sync);
    const sourceObserver = new MutationObserver(sync);
    sourceObserver.observe(sourceForm, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    sync();
  };

  document.addEventListener('DOMContentLoaded', initializeCueticaBuyBar);
  document.addEventListener('shopify:section:load', initializeCueticaBuyBar);

})();
